export default [
  // 도봉구
  {
    name: "도봉마을예술창작소",
    position: { lat: 37.686777, lng: 127.03911 },
    staff: undefined,
    addr: "서울시 도봉구 도봉동 553번지",
    tel: undefined,
    website: undefined,
    desc: "도봉마을예술창작소",
    imgs: undefined
  },
  {
    name: "아수라",
    position: { lat: 37.689891, lng: 127.04314 },
    staff: undefined,
    addr: "서울시 도봉구 도봉로 955 도봉산 광역환승센터 1층 5호",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  // 강북구
  {
    name: "싸롱드비",
    position: { lat: 37.648197, lng: 127.013565 },
    staff: undefined,
    addr: "서울시 강북구 수유동 279-127 지하",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  {
    name: "이미지 세탁소",
    position: { lat: 37.626981, lng: 127.034289 },
    staff: "담당자: 이상수, 김명희",
    addr: "서울시 강북구 오현로25길 79 B1",
    tel: "070-8810-7128",
    website: undefined,
    desc: `1. 나도 감독이다
      스마트폰 기기 하나만으로 우리 동네 홍보영상, 단편영화, 뮤직비디오, 인터뷰 등 다양한 지역 특화형 영상 콘텐츠를 손쉽게 제작하고 싶은 분들을 위한 영상 기초 교육 및 제작
      2. 우리 동네 흑역사(黑歷寫)
      우리가 살고 있는 복잡한 세상을 간결한 흑백의 이미지로 변환시키면서 정서적 안정과 아날로그의 감성을 향유하고, 소소한 일상과 동네의 모습을 주제로 매주 한 번씩 진행하는 흑백사진 공유 모임
      3. 수작(水作)
      매주 수요일에 진행되는 주민 창작 작당 모의로 지역에서 필요한 문화예술 프로그램을 주민들과 함께 기획하고 실천하는 모임
      4. 이미지 세탁 SHOW
      주민들이 살아가는 터전에서 직접 만들어가는 창작활동을 통해 동네의 잠재된 정보, 문화, 예술 활동을 주민들과 교류하며 소통할 수 있는 전시 진행`,
    imgs: [
      require("../../assets/img/locations/1.jpg"),
      require("../../assets/img/locations/2.jpg")
    ]
  },
  // 노원구
  {
    name: "수락샘",
    position: { lat: 37.687356, lng: 127.054014 },
    staff: undefined,
    addr: undefined,
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  {
    name: "토토도공들",
    position: { lat: 37, lng: 126 },
    staff: "대표 : 강문순 / 실무 : 김시내",
    addr: "서울시 노원구 상계2동 434-42호 지층/1층",
    tel: "02-934-6002 / 010-8703-2331",
    website: undefined,
    desc: `자유로운 도자기예술창작소와 도자카페사랑방 토토갤러리 & 토토공방 
      주요 프로그램 : 성인반 생활도자기동아리, 아동반 흙놀이창의도예, 유치부 주물주물 도자기와 놀자, 청소년부 도자기동아리활동, 마을이학교다 도예교실, 주말엔 엄마와 아이와함께 도자기만들기,
      가족도자기예술창작반, 전기물레수업반, 유치부 아동미술활동, 핸드페인팅부, 각종 1일체험 등`,
    imgs: [
      require("../../assets/img/locations/3.jpg"),
      require("../../assets/img/locations/4.jpg"),
      require("../../assets/img/locations/5.jpg"),
      require("../../assets/img/locations/6.jpg"),
      require("../../assets/img/locations/7.jpg"),
      require("../../assets/img/locations/8.jpg")
    ]
  },
  // 은평구
  {
    name: "꿈꾸는 작업실",
    position: { lat: 37.601976, lng: 126.918509 },
    staff: "김세희 / 장주희",
    addr: "서울시 은평구 진흥로1길 17",
    tel: "070-7518-2148",
    website: "www.kkumda.co.kr",
    desc: `1. 주민 동아리 사업
      누구나 배우고 가르치는 문화 프로그램
      우리 술 만들기, 보드게임 만들기, 전통놀이, 벨리댄스 등 다양한 프로그램으로 구성
      www.epuniv.co.kr으로 모집
      2. 드림아카데미
      청소년들이 스스로 원하는 활동을 체험하는 문화예술프로그램.
      마을 사람들이 멘토가 되어 함께 진행.`,
    imgs: [
      require("../../assets/img/locations/9.jpg"),
      require("../../assets/img/locations/10.jpg")
    ]
  },
  // 종로구
  {
    name: "창신소통공작소",
    position: { lat: 37.577402, lng: 127.01198 },
    staff: "손경주/하연주",
    addr: "서울시 종로구 창신동 23-313, 창신3동 제1공영주차장",
    tel: "02-2088-1270",
    website: "facebook.com/changsindong.story",
    desc: `
      1. 주민들과 함께 하는 공작프로그램
      <꼼지락꼼지락 손공작, 뚝딱뚝딱 목공작, 드르륵 봉제공작>
      그리기, 만들기, 수놓기, 쓰기, 엮기, 도자 등 손끝에서 피어나 삶에 쓸모를 더하는 손공작 활동, 기초 공구사용법부터
      실생활에 유용한 실전 목공수업, 봉제의 메카 창신동의 특별한 시간! 나만의 개성이 살아있는 생활 소품과 나만의
      옷 만들기 등2. 씨앗 프로젝트
      <쫑알쫑알 소통>
      정기/비정기적 오픈형 라운드테이블을 통한 걱정모임. 공작소의 활동경험을 재해석하는 과정을 통해
      주민 누구나 참여 가능한 회의와 공부모임. 정기회의, 워크숍, 연간 활동을 정리하는 연말 쫑알 전시회를 개최합니다.
      <주민예술동아리 꼼지락 공작>
      열린 공작방, 취미공유클럽, 우리 마을 뭐든지 예술 프로젝트 등 배움의 즐거움을 나누고 마을공동체의 예술경험을
      확장하는 프로젝트

      3. 창작 페스티벌
      왁자지껄 창신! 연 2회 예술동아리 및 주민들의 창작활동 결과물을 공유하여 누구나 예술가가 되는 경험의 전시회,
      페스티벌기간동안 마을의 특색, 자원 등을 반영한 설치 예술 작품 제작과 프로그램 진행, 창작을 키워드로 한
      플리마켓을 개최
      `,
    imgs: [
      require("../../assets/img/locations/11.jpg"),
      require("../../assets/img/locations/12.jpg")
    ]
  },
  // 성북구
  {
    name: "우리동네 아뜰리에",
    position: { lat: 37.597489, lng: 127.010252 },
    staff: "김진경",
    addr: "서울시 성북구 돈암동 602-258",
    tel: "010-8012-5515",
    website: "https://www.facebook.com/sbwooa/",
    desc:
      "성북 크루즈 3D, 우리동네 연극 놀이터, 상자 꽃밭가꾸기와 미술활동, 축제 한마당",
    imgs: [
      require("../../assets/img/locations/13.jpg"),
      require("../../assets/img/locations/14.jpg"),
      require("../../assets/img/locations/15.jpg")
    ]
  },
  {
    name: "잇다",
    position: { lat: 37.605077, lng: 127.015601 },
    staff: "신희경, 염승민",
    addr: "서울시 성북구 서경로2길 21 1층",
    tel: "02-942-7766",
    website: "www.youthforest.net",
    desc: `
      1. 아동과 상상을 잇다
      세상의 하나뿐인 내 그림책 만들기
      2. 청소년과 진로를 잇다
      업사이클과 요리를 매개로 하는 다양한 경험을 통해 자신의 삶을 디자인하는 동아리활동
      3. 학부모들을 잇다
      소곤소곤 문화예술 사랑방
      아동청소년자녀의 학부모를 대상으로 하는 자기이해와 성장의 시간
      4. 놀이워크숍
      놀이를 통한 아동•청소년의 배움과 성장을 추구하는 연구모임 및 워크숍
      `,
    imgs: [
      require("../../assets/img/locations/16.jpg"),
      require("../../assets/img/locations/17.jpg")
    ]
  },
  {
    name: "키득키득 길음예술사랑방",
    position: { lat: 37.59413, lng: 126.991811 },
    staff: "대표 : 성낙경 / 실무 : 김은정",
    addr: "서울시 성북구 성북동 227-2",
    tel: "010-9159-3142",
    website: "www.facebook.com/Kideugkideug",
    desc: `함께 모여 신나게 놀자~ 키득키득 ‘길음 예술사랑방’
      키득키득 길음예술사랑방은 길음동에서2012년 길음중학교 추진을 중심으로 모인 학부모들의 기업으로 , 서울시 마을예술창작소를 함께 운영합니다.
      생활예술활동을 통해 사람과 사람을 연결하는, 아이들이 건강하게 자라는 마을을 꿈꾸는, 꿈꾸고 그 꿈을 실현하는 공간입니다 .
      아이들의 그림을 잘 그리게 하기 보다는 아이들과 신나게 놀고 싶습니다 .
      아이들이 미술 작업을 놀이처럼 즐거운 시간이 될 수 있도록 수업을 할 예정입니다 .
      그러므로 결과물보다는 작업과정이 더 중요하고 아이들이 자신의 생각과 느낌을 맘껏 풀어내는 것이 중요하다고 생각합니다.
      `,
    imgs: [
      require("../../assets/img/locations/18.jpg"),
      require("../../assets/img/locations/19.jpg"),
      require("../../assets/img/locations/20.jpg"),
      require("../../assets/img/locations/21.jpg")
    ]
  },
  {
    name: "행복한 정릉 창작소",
    position: { lat: 37, lng: 126 },
    staff: "대표 : 김경아",
    addr: "서울시 성북구 정릉1동 110-43",
    tel: "010-2397-6789",
    website: "",
    desc:
      "동네사람들을 위한 유쾌한 쉼터, 놀이터, 배움터 / 주요 프로그램 : 문화예술강습, 어린이 놀이 모임, 동네 극장, 각종 모임 대관",
    imgs: [
      require("../../assets/img/locations/22.jpg"),
      require("../../assets/img/locations/23.jpg"),
      require("../../assets/img/locations/24.jpg")
    ]
  },
  // 서대문구
  {
    name: "마을예술창작소 닷라인TV",
    position: { lat: 37.584946, lng: 126.939104 },
    staff: "대표 : 문예진",
    addr: "서울시 서대문구 홍제1동 356-102번지",
    tel: "070-4312-9098 / 010-6566-9098",
    website: "dotlinetv.com",
    desc: `
      “신나는 마을미술관 닷라인TV”
      주요 프로그램 : <마을예술방송국> <마을팩토리> <담벼락 극장> <동네 양말 다나와 프로젝트>
      <문패프로젝트> <예술가 레지던시> <내가 만드는 영화 보기 Day> <오픈부엌> 쓱쓱 싹싹 캐리커처 수업, 통기타 커뮤니티, 나도 도예가, 모던보이의 동양화그리기또르륵 DIY 손가구, 커뮤니티아트 전시
      `,
    imgs: [
      require("../../assets/img/locations/25.jpg"),
      require("../../assets/img/locations/26.jpg"),
      require("../../assets/img/locations/27.jpg"),
      require("../../assets/img/locations/28.jpg")
    ]
  },
  // 중구
  {
    name: "엮임",
    position: { lat: 37.559529, lng: 127.014375 },
    staff: "담당자: 김이영",
    addr: "서울시 중구 다산로 28길 14",
    tel: "010-3008-2391",
    website: undefined,
    desc: `
      1.엄마는 이제 예술가
      니팅, 퀼트, 프랑스 자수 등의 생활 공예 활동
      2.소통의 즐거움
      지역 노인들과 함께 취미를 공유하며 만드는 소통
      3.동네 아트프리마켓, 중구 생활문화 동호회 활동
      취미활동에서 더 나아가 작품 전시 등으로 숨겨진 재능 발굴
      `,
    imgs: [
      require("../../assets/img/locations/29.jpg"),
      require("../../assets/img/locations/30.jpg")
    ]
  },
  // 성동구
  {
    name: "미니프린트",
    position: { lat: 37.537631, lng: 127.054136 },
    staff: "담당자: 최승현, 사만다 블루멘펠드",
    addr: "서울시 성동구 성덕정길 95 2층",
    tel: "010-4930-2484",
    website: "www.miniprintseoul.com",
    desc: `
      1. 열린 예술 공간
      마을 주민이 주체가 되어 진행되는 창작예술 활동 공간
      전시, 예술 활동, 서클활동 공간 제공(전시회 기획, 음악회, 예술기획단 모임 등)
      마을극장, 아트프리마트
      2. 마을 판화 프로그램
      판화 워크숍: 실크스크린, 볼록판화, 원데이
      열린 판화공간: 판화장비를 이용하고 자유로운 판화 창작활동 지원
      3. 미술 치료, Art Therapy(영어로 진행)
      미술을 통해 트라우마, 우울증 등 을 극복하고 서로 소통하는 서포트 구룹입니다.
      누구나 참여 가능하며 특히 국내 거주 외국인 등 소외된 계층에게 힘이 되고자 합니다.`,
    imgs: [
      require("../../assets/img/locations/31.jpg"),
      require("../../assets/img/locations/32.jpg")
    ]
  },
  {
    name: "웹툰 발전소",
    position: { lat: 37.536527, lng: 127.059278 },
    staff: undefined,
    addr: "성동구 성덕정길 143 2층",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  // 광진구
  {
    name: "광진 뉴아틀리에",
    position: { lat: 37.556774, lng: 127.081927 },
    staff: "운영자: 권상오, 박지현",
    addr: "서울시 광진구 천호대로 111길 7(중곡동) 2층",
    tel: "02-565-8042",
    website: "facebook.com/groups/guangjinatelier/",
    desc: `
      1. 예술로 나누는 서로의 마음
      종이와 펜 : 종이와 펜만 있으면 나도 화가, 새로운 시각: 핸드폰으로 바라보는 우리 마을
      디지털 다이어리: 컴퓨터로 그려내는 나의 일상
      2. 전통과 함께 하는 즐거움
      한지공예 : 한지로 만드는 쌀독, 할머니의 손맛: 할머니에게 배우는 자수, 뜨개질
      3. 다양한 커뮤니티
      Open Market, 다양한 커뮤니티 소공연, 강연
      `,
    imgs: [
      require("../../assets/img/locations/33.jpg"),
      require("../../assets/img/locations/34.jpg")
    ]
  },
  // 강서구
  {
    name: "꿈샘누리",
    position: { lat: 37, lng: 126 },
    staff: "김화경 / 김수경",
    addr: "서울특별시 강서구 공항동 초원로16길 80, 301호",
    tel: "010-2742-6764 / 010-2464-6764",
    website: "https://band.us/band/56736910",
    desc: `
      1.생활 공예
      생활 속의 다양한 재료를 활용한 창의적 만들기 모임
      : 냅킨아트,가죽공예,북아트,풍선아트,방향제,비누만들기 등
      2.도예
      남녀노소 누구나 즐기는 흙 놀이
      : 기초도예, 물레체험, 핸드페인팅
      3.소셜다이닝
      건강한 식생활을 모토로 바른 먹거리, 친환경 식생활 등을 함께하는 밥상 모임
      `,
    imgs: [
      require("../../assets/img/locations/35.jpg"),
      require("../../assets/img/locations/36.jpg")
    ]
  },
  // 양천구
  {
    name: "라온리에",
    position: { lat: 37.550292, lng: 126.864505 },
    staff: undefined,
    addr: "서울시 양천구 목동중앙북로1길 37 ",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  {
    name: "플러스마이너스1도씨",
    position: { lat: 37.54362, lng: 126.877973 },
    staff: "대표 : 김지영",
    addr: "서울시 양천구 목동 202-16",
    tel: "02-2642-5361",
    website: "https://m.facebook.com/profile.php?id=436820376338645",
    desc: `일상의 감각을 깨우는 마을 안 예술발전소, ‘모기동문화발전소’
      누구나 삶을 풍요롭게 만들고, 누릴 수 있어야 합니다.
      모기동문화발전소(플러스마이너스1도씨)는 그러한 실천을 예술로 해나가는 사람들이 모여있는 곳입니다.
      삶의 터전에서 비롯된 예술은 개인, 넓게는 공동체에 적지않은 영향을 미친다는 믿음을 갖고 관계성 안에서 ‘일거리’, ‘놀거리’, ‘작업거리’를 스스로 만들며 삶의 문화를 서서히, 지속적으로 쌓아가는 곳입니다.
      동네 친구, 동네 언니(오빠)가 선생님이자 예술가가 되고, 사람과 사람이 만나고 예술과 마을이 만나는 플랫폼.누구나 자발적으로 자신들의 숨은 재능을 발견하고 발현할 수 있는 실험의 장이자 함께 배우고 경험하며 성장하는 문화를 만들어가는 곳, ‘모기동문화발전소’가 꿈꾸는 마을예술창작소 입니다.
      `,
    imgs: [
      require("../../assets/img/locations/37.jpg"),
      require("../../assets/img/locations/38.jpg"),
      require("../../assets/img/locations/39.jpg"),
      require("../../assets/img/locations/40.jpg")
    ]
  },
  // 영등포구
  {
    name: "영등포구 문래예술공방",
    position: { lat: 37.51348, lng: 126.893928 },
    staff: "대표 : 유재영 / 실무 : 이용희",
    addr: "서울시 영등포구 문래동 3가 58-37",
    tel: "070-4025-2012 / 010-3444-0719",
    website: "https://cafe.naver.com/artcommune",
    desc:
      "주로 재봉틀 위주의 수업 및 모임이 진행되며 가구업사이클링 등 적정 기술을 이용한 다양한 프로그램이 진행됩니다. 나눌 수 있는 경험과 기술이 있는 주민이 필요한 주민과 자유롭고 평등하게 만나는 공간이자 그 활동이 예술적인 성장으로 이루어지게끔 지원 촉진하는 공간입니다.",
    imgs: [
      require("../../assets/img/dummy-1.jpg"),
      require("../../assets/img/dummy-2.jpg"),
      require("../../assets/img/dummy-3.jpg"),
      require("../../assets/img/dummy-4.jpg")
    ]
  },
  {
    name: "선유마을 재활용 공작단",
    position: { lat: 37.537839, lng: 126.89532 },
    staff: "대표 : 배지훈",
    addr: "서울시 영등포구 선유로 51길 28 명천빌딩 지하1층",
    tel: "02-6083 3224 / 단장 배지훈 : 010-3206-0538",
    website: undefined,
    desc: `
      함께 느끼는 문화소통 공간, 함께 만드는 업싸이클링 예술창작단
      선유마을 재활용 공작단
      주요 프로그램 : 마을예술가 주도 문화공방 클래스, 선유마을 주민의 커뮤니티 쉼터(상시운영) ,
      마을 생활폐기물을 활용해 업싸이클링 제품제작, 마을 예술가와 주민의 작은 전시 및 공연
      `,
    imgs: [
      require("../../assets/img/locations/41.jpg"),
      require("../../assets/img/locations/42.jpg")
    ]
  },
  {
    name: "세바퀴",
    position: { lat: 37.523999, lng: 126.88823 },
    staff: "유은옥, 박혜영, 김명희",
    addr: "서울시 영등포구 양동1가 217-20번지 2층",
    tel: "010-7133-2903",
    website: "band.us/@201703art",
    desc: `
      1. 나도야 예술가!
      전통공예(한복,한지,지끈,매듭공예,민화), 궁중떡, 전통식문화
      생활공예(퀼트, 삭스돌, 가죽공예, 목공, 친환경 리빙, 리사이클 공예)
      2. 한바퀴, 두바퀴, 세바퀴 예술소모임
      욜로영화모임, 햅번맘’s, fab마더’s목공, 콩밭장독대
      3. 문화예술교육공동체 Triangle-A
      예술체험 박람회, 역사관 예술전시, 돗자리 영화제
      `,
    imgs: [
      require("../../assets/img/locations/43.jpg"),
      require("../../assets/img/locations/44.jpg")
    ]
  },
  // 구로구
  {
    name: "수궁헛간 : 수상하고 궁금한 마을헛간",
    position: { lat: 37.496906, lng: 126.829593 },
    staff: "대표 : 박경식",
    addr: "서울시 구로구 오리로 1294",
    tel: "02-2685-2622",
    website: "https://www.facebook.com/leela2010",
    desc: `
      마을예술창작소 “수상하고 궁금한 마을헛간”(이하 수궁헛간)은 구로구 수궁동(구로구 오리로 1294)에 위치하고 있습니다.
      처음 공방 “나무그늘아래”로 시작된 이공간은 지역주민, 학생, 활동가를 중심으로 강좌와 모임이 만들어지고 나무그늘아래공방(디자인강좌, 전시회), 널판지목공학교(청소년, 학생, 마을주민대상의
      목공강좌, 진로교육), 그루터기놀이터(어린이대상 체험 놀이터), 우리동네 마을헛간(마을주민의
      문화예술창작활동의 공동작업장)의 활동을 중심으로 지역내 예술가와 활동가 그리고, 다양한기관(복지관, 교육복지센터, 학교, 청소년상센터, 마을넷, 건강가정지원센터)들과 네트워크를 형성 다양한 활동을 전개하고 있습니다.
      `,
    imgs: [
      require("../../assets/img/locations/45.jpg"),
      require("../../assets/img/locations/46.jpg"),
      require("../../assets/img/locations/47.jpg"),
      require("../../assets/img/locations/48.jpg")
    ]
  },
  // 금천구
  {
    name: "어울샘",
    position: { lat: 37.451774, lng: 126.911643 },
    staff: "대표 : 김수현 위원장 / 실무 : 송재희 간사",
    addr: "서울시 금천구 시흥5동 탑골로22번지",
    tel: "02-809-7860 / Fax : 02-809-7861",
    website: "https://www.facebook.com/eoulsam",
    desc: `
      동네 사람들이 어울려 즐거운 소리가 울려 퍼지는 마을 샘터  ‘어울샘’
      2013년 금천구에 마을예술창작소 어울샘이 문을 열었습니다. 은행나무 길을 지나 시흥5동 탑골로22번지에 위치한 이곳엔 원래 폐가압장이 자리잡고 있었지만 그 모습을 벗고 마을 사람들을 위한 창작공간으로 마침내 탈바꿈 했습니다.
      마을의 물을 공급해주며 만남의 장이 되었던 가압장의 의미를 본따, 마을 사람들이 문화예술을 통해 어우러지는 공간이 되고자 하는 마음으로 어울샘이라는 이름을 붙였습니다.
      어울샘은 지역 동아리들이 모여 예술적 재능을 나누는 문화사랑방, 생활 속에서 문화예술활동을 생산하는 동네 공방, 따뜻한 밥을 짓고 나누는 마을 부엌 등 여러 활동을 통해 찾아오는 이웃들과 마을에 대한 이야기를 나누는 샘터가 되고자 합니다.
      우리는 모두 삶의 예술가들입니다. 마음을 표현하고자 하는 의지만 있다면 놀러오세요 .
      사람이 있어야 공간이 살아 움직입니다. 금천마을예술창작소 어울샘의 공간을 채워 줄 마을사람들을 기다립니다.
      `,
    imgs: [
      require("../../assets/img/locations/49.jpg"),
      require("../../assets/img/locations/50.jpg"),
      require("../../assets/img/locations/51.jpg"),
      require("../../assets/img/locations/52.jpg")
    ]
  },
  {
    name: "청춘(靑春)문화예술학교",
    position: { lat: 37.450159, lng: 126.913339 },
    staff: undefined,
    addr: "서울시 금천구 시흥동 금하로 753, 4층",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  },
  // 동작구
  {
    name: "꼼지락 공예소",
    position: { lat: 37.503818, lng: 126.949496 },
    staff: "대표 : 인선화",
    addr: "서울시 동작구 상도1동 628번지",
    tel: "010-2929-4140",
    website: "https://cafe.naver.com/swwa1/1294",
    desc: `
      배우고, 배려하고, 베풂이 있는 동작마을예술창작소 꼼지락공예(재주 예, 수다스러울 예)소
      주요 프로그램 :
      수공예 : 홈패션, 천연비누, 천연화장품, 냅킨아트, 리본아트 & 선물포장, 풍선아트, 캔들외 다수
      피바리스타(현재 수강생이 직접 바리스타 무료위탁운영중 : 전기세, 수도세, 임대료 안 받음),
      에니어그램심리분석, 부모교육, 베이비마사지, 키즈요가, 임산부태교요가, 아동요리, 식습관코치외 다수
      `,
    imgs: [
      require("../../assets/img/locations/53.jpg"),
      require("../../assets/img/locations/54.jpg"),
      require("../../assets/img/locations/55.jpg")
    ]
  },
  // 관악구
  {
    name: "달달한동네",
    position: { lat: 37.474242, lng: 126.93529 },
    staff: "대표 : 조성호, 남일",
    addr: "서울시 관악구 난곡, 난향, 미성동 일대(정확한 주소 없음)",
    tel: "070-7098-5945",
    website: "http://cafe.daum.net/nangokart",
    desc:
      "실체가 없는 듯한, 하지만 어디에나 존재하는 달달한 동네 난곡예술창작소 ‘달달한동네’",
    imgs: [
      require("../../assets/img/locations/56.jpg"),
      require("../../assets/img/locations/57.jpg"),
      require("../../assets/img/locations/58.jpg")
    ]
  },
  // 서초구
  {
    name: "삼삼오오 마술소",
    position: { lat: 37.470316, lng: 127.039187 },
    staff: "담당자: 최혜령",
    addr: "서울시 서초구 방배동 839-4 2층 밸류가든",
    tel: "010-6429-4683",
    website: undefined,
    desc: `
      손으로 하는 아침: 플라워 레슨 등
      글로 여는 아침: 글쓰기 강좌, 낭독 모임등
      맛으로 여는 아침: 쿠킹 클래스, 맛내기 레시피 공유 및 마을 내 숨은 ‘맛의 고수’ 소개
      도슨트 강좌: 서초구 관내 활동하는 도슨트들과 연계한 찾아가는 미술관 수업
      영화 감상: 월마다 주제를 선정하여 관련 영화 감상 및 토론
      오픈 작업장 운영: 누구나 사용 가능한 자유로운 창작 활동 공간 및 재료 지원
      `,
    imgs: [
      require("../../assets/img/locations/59.jpg"),
      require("../../assets/img/locations/60.jpg")
    ]
  },
  {
    name: "꿈씨꿈틀",
    position: { lat: 37.457578, lng: 127.018166 },
    staff: "운영자: 심미경. 박진",
    addr: "서울시 서초구 양재대로 2길 90 서초힐스 멀티실",
    tel: "010-4272-4675",
    website: undefined,
    desc: `
      1. 세대공감 열린 공방 소모임 활동
      함께 배우기: 아름다운 소리 플루트. 쉽게 접하지 못하는 전통공예, 다양한 공예를 함께 체험하는 토탈공예
      2. 가족모두가 행복한 문화예술 공동쳬 만들기
      문화가 있는 토요일에 즐거움이 있으라!
      수제 비누를 가족과 함께. 작은 연주회. 옛 문화의 멋을 찾아서
      규방 공예, 실버들의 반란
      3. 문화적 공감대를 형성하는 지역 공동쳬 회복 활동
      풍선아트, 공예 작품 전시회. 음악 발표회
      `,
    imgs: [require("../../assets/img/locations/61.jpg")]
  },
  // 강동구
  {
    name: "즐거운가",
    position: { lat: 37.484209, lng: 127.130006 },
    staff: "이윤복(복실) / 실무 : 오승관(승짱)",
    addr: "서울시 송파구 새말로 149 지하(문정동)",
    tel: "070-4192-1318 / 팩스 : 02-404-1318",
    website: "https://www.facebook.com/jollyhouse2010",
    desc: `지금은 없어진 문정동 비닐하우스촌 개미마을에서 <송파 꿈나무학교 공부방>으로 초등학생 친구들과 만나기 시작하여 <무지개빛청개구리지역아동센터>를 거쳐 중고등부 친구들과 <함께 웃는 마을공동체 , 즐거운가>로 이르기까지 그동안 참 많은 꿈을 꾸어 왔습니다. 밥을 굶지 않았으면 좋겠다는 꿈, 공부를 못해도 학교에서 들러리가 되지 않았으면 좋겠다는 꿈, 가난을 부끄럽지 않게 생각하고 싶다는 꿈, 모래알같이 흩어진 친구들을 단단하게 이어주고 싶다는 꿈, 밴드 연습실을 갖고 싶다는 꿈, 어른을 믿고 싶다는 꿈, 마을과 함께 자라고 싶다는 꿈, 이 많은 꿈들 중 많은 것들이 지금 현실이 되었고, 또 현실이 되어가고 있습니다.`,
    imgs: [
      require("../../assets/img/locations/62.jpg"),
      require("../../assets/img/locations/63.jpg"),
      require("../../assets/img/locations/64.jpg"),
      require("../../assets/img/locations/65.jpg"),
      require("../../assets/img/locations/66.jpg"),
      require("../../assets/img/locations/67.jpg")
    ]
  },
  {
    name: "다락",
    position: { lat: 37.501891, lng: 127.109641 },
    staff: "대표 : 허미경 / 실무 : 김정아",
    addr: "서울시 송파구 송파대로 지하 384",
    tel: "02-412-2233",
    website: "http://www.masulso.org/home/",
    desc: `송파구 송파사거리에 위치한 송파마을예술창작소(송파마술소)는 방치되어 버려진 지하보도를 문화공간으로 탈바꿈시켜 송파 지역 내 독특하고 개성 있는 문화예술 공간으로의 입지를 넓혀가고 있습니다.
      간혹 모르는 사람들이 지하철역이거나 지하상가쯤으로 오해하여 들어오는 분도 계시지만 오히려 그렇게 들어오신 분들은 기대치 않은 공간이 있다는 사실에 놀라움과 기쁨을 표현하기도 하는 반전의 공간인 셈이죠.
      특히 이곳에서 생활공예를 포함한 미술분야와 음악분야 등 다양한 문화예술 강좌가 진행되고 있다는 사실에 더 반가움을 표시하기도 합니다 .
      송파마술소의 운영주최는 문화예술을 즐기는 시민 자원봉사자들이 중심이 되어 구성된 운영위원으로 각자의 재능을 기반으로 역할을 맡아서 송파마술소가 마을에서 활동하도록 하는데 자신의 시간을 쪼개가며 노력과 정열을 쏟고 있습니다 .
      게다가 공간의 활용도를 높일 뿐 아니라 지역 내에서 활동하는 다양한 단체들과의 네트워크 형성을 위해 지역 마을활동가들이나 문화예술단체들과 송파마술소의 공간의 공유하고 있으며 그들과 정보를 공유하며 인력 인프라를 확장해 나가고 있습니다.`,
    imgs: [
      require("../../assets/img/locations/68.jpg"),
      require("../../assets/img/locations/69.jpg")
    ]
  },
  {
    name: "스페이스휴",
    position: { lat: 37.508506, lng: 127.123315 },
    staff: "대표 : 이형대",
    addr: "서울시 송파구 오금로 31길 27 코오롱@상가 지하1층",
    tel: "02-2202-0425 / 010-6335-0923",
    website: "https://www.facebook.com/hyungdae.lee.7",
    desc:
      "사람과 자연이 함께하는 공간 스페이스휴 / 주요 프로그램 : 청소년 목공동아리 달class, 지역성인목공동아리 아빠달class, 정규목공 DIY목공반(초급반/중급반/고급반), 전문가반(창업반/짜맞춤반)",
    imgs: [
      require("../../assets/img/locations/70.jpg"),
      require("../../assets/img/locations/71.jpg")
    ]
  },
  {
    name: "이루다 손",
    position: { lat: 37.491858, lng: 127.124823 },
    staff: "대표 : 남주현(소머즈) / 실무 : 서승미(윈디아)",
    addr: "서울시 송파구 송이로 26길 7-17 1층 까페 <심지>",
    tel: "010-2068-6369 (이루다손 소머즈)",
    website: "cafe.naver.com/irudason",
    desc: `손으로 만드는 자유, 마을에서 누리는 기쁨
      마을예술창작소 – 이루다손
      우리 손으로 이루다는 그 ‘사람’을 바라봅니다. 우리에게 다가 오는 사람을 감사히 맞아 그대로를 존중하며 관계를 맺고 신뢰를 쌓아가는 우리로 다시 이어지기를 기대합니다.
      수공예, 목공, 천연화장품 만들기 등의 시간은 쓰고 버리는 소비의 관성에서 벗어날 수 있는, 현대의 삶을 되돌아볼 수 있는 계기가 될 수 있기를 기대하며 함께 하는 시간 속에서 더욱 다양하게 이웃을 만나며 관계 맺기를 경험합니다. 그 안에선 서로의 이야기와 감정이 오가고 , 관계들이 깊어지며 신뢰가 쌓입니다. 이런 과정을 통해 든든해진 모임은 이미 지역의 부모모임이나 대안적 삶을 위한 공동체 모임 등의 구심점 역할을 하고 있습니다.`,
    imgs: [
      require("../../assets/img/locations/72.jpg"),
      require("../../assets/img/locations/73.jpg"),
      require("../../assets/img/locations/74.jpg"),
      require("../../assets/img/locations/75.jpg"),
      require("../../assets/img/locations/76.jpg")
    ]
  },
  // 강동구
  {
    name: "유쾌한 악당",
    position: { lat: 37.552348, lng: 127.129108 },
    staff: "담당자: 김윤아",
    addr: "서울시 강동구 암사동 463-25(고덕로 8길 51)",
    tel: "070-4201-7787",
    website: undefined,
    desc: `
      1.예술놀이터
      유쾌한 악당에서 즐기는 연극·음악·미술·움직임·공예 등의 통합 예술 활동
      2.우리 동네 북새통
      동네 작은 커뮤니티 공간에서 가족과 함께 공연 관람
      3.예술로 동아리 네트워크 밥상
      지역의 예술가들과 예술 활동에 관심 있는 주민들과의 작당모의.
      `,
    imgs: [
      require("../../assets/img/locations/77.jpg"),
      require("../../assets/img/locations/78.jpg")
    ]
  },
  {
    name: "행복한 마을예술창작소",
    position: { lat: 37.557587, lng: 127.157008 },
    staff: undefined,
    addr: "서울시 강동구 동남로 930",
    tel: undefined,
    website: undefined,
    desc: undefined,
    imgs: undefined
  }
];
